import { combineReducers } from '@reduxjs/toolkit';
import {
  put,
  call,
  select,
  fork,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { getImagesMetadata, getProject } from '../utils/zoomServices';
import { Map, fromJS } from 'immutable';
import * as Selectors from '../reducers/selectors';
import pageItems from './pageItems';
import pages, {
  GENERATE_THUMB_COMPLETE,
  SET_GENERATE_THUMB_COUNT,
} from './pages';
import reviewProject from './reviewProject';
import sections from './sections';
import { selectPages, selectSection, selectPageItems } from './selection';
import PicabooConstants from '../common/PicabooConstants';
import undoable, { includeAction, ActionCreators } from 'redux-undo';
import * as PageItem from './pageItems';
import * as Page from './pages';
import * as Background from './backgrounds';
import productInfo from './productInfo';
import { handleCreateThumbnail } from './changesets';
import {
  setZoomLevel,
  renderCanvasFromStore,
  keepSelectedTab,
  enterShareView,
  enterPreviewMode,
  toggleAutoFillPromptModal,
  toggleAutoFillWaitModal,
} from './navigation';
import { clearSelection } from './selection';
import { setWrapDimensions } from './wrap';
import { setSelectedSKU } from './selection';
import { setLoadedImagesSection } from './loadedImages';
import { IMAGE_ADDED } from '../sagas/ReturnedChangesetProcessor';
import { getParameterByName } from '../utils/general';
import { createBrowserHistory } from 'history';
import { obfuscateProjectId } from '../utils/projectId';
import imageUsage from './imageUsage';
import { imagesToUploadCount } from '../reducers/selectors';
import { loadPricing } from './pricing';
const history = createBrowserHistory();

export const LOAD_PROJECT = 'LOAD_PROJECT';
export const SHARE_PROJECT = 'SHARE_PROJECT';
export const LOAD_PROJECT_UNDOABLE = 'LOAD_PROJECT_UNDOABLE';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_REVIEW_PROJECT = 'SET_REVIEW_PROJECT';
export const SET_PROJECT_UNDOABLE = 'SET_PROJECT_UNDOABLE';
export const ADD_PROJECT_IMAGE = 'ADD_PROJECT_IMAGE';
export const ADD_PROJECT_IMAGE_REF = 'ADD_PROJECT_IMAGE_REF';
export const DELETE_PROJECT_IMAGE_REF = 'DELETE_PROJECT_IMAGE_REF';
export const REMOVE_PROJECT_IMAGE = 'REMOVE_PROJECT_IMAGE';
export const REMOVE_PROJECT_UNUSED_IMAGES = 'REMOVE_PROJECT_UNUSED_IMAGES';
export const SAVE_PAGES_FROM_STORE = 'SAVE_PAGES_FROM_STORE';
export const SAVE_SPREAD_FROM_STORE = 'SAVE_SPREAD_FROM_STORE';
export const SAVE_CURRENT_SPREADS_FROM_STORE =
  'SAVE_CURRENT_SPREADS_FROM_STORE';
export const TOGGLE_ORIENTATION = 'TOGGLE_ORIENTATION';
export const ORIENTATION_TOGGLED = 'ORIENTATION_TOGGLED';
// export const ORIENTATION_TOGGLED_SAGA = 'ORIENTATION_TOGGLED_SAGA';
export const NAME_CHANGED = 'NAME_CHANGED';
export const RENAME_PROJECT = 'RENAME_PROJECT';
export const HEADERS_CHANGED = 'HEADERS_CHANGED';
export const UPDATE_HEADERS = 'UPDATE_HEADERS';
export const REMOVE_FROM_CART_SAGA = 'REMOVE_FROM_CART_SAGA';
export const CHANGE_PROJECT_STYLE = 'CHANGE_PROJECT_STYLE';
export const SPREAD_DELETED = 'SPREAD_DELETED';
export const SPREADS_ADDED = 'SPREADS_ADDED';
export const UNDO = 'project/UNDO';
export const REDO = 'project/REDO';
export const UPLOAD_THUMB = 'project/UPLOAD_THUMB';
export const CREATE_NEW_PAGE_THUMB = 'CREATE_NEW_PAGE_THUMB';
const AUTO_FILL_PROJECT = 'AUTO_FILL_PROJECT';
const UPDATE_PAGE_NUMBER_STYLE = 'project/UPDATE_PAGE_NUMBER_STYLE';

const UPDATE_COVER_TYPES = 'project/UPDATE_COVER_TYPE';
const UPDATE_WARNINGS = 'UPDATE_WARNINGS';

export const UPDATE_PAGE_NUMBER_SETTINGS =
  'project/UPDATE_PAGE_NUMBER_SETTINGS';

const initialState = fromJS({
  project: Map(),
  isLoaded: false,
  type: undefined,
  loadingProject: true,
  generatingThumbCount: 0,
});

/**
 * Retucers
 */

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PROJECT:
    case LOAD_PROJECT_UNDOABLE:
      return state.set('loadingProject', true);
    case UPDATE_WARNINGS:
      state = state.set('warnings', action.warnings);
      return state;
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      if (state === initialState) {
        let initialProject = fromJS(action.project.project)
          .set('isLoaded', true)
          .set('loadingProject', false);

        return initialProject;
      } else {
        if (
          action.project != undefined &&
          action.project.project != undefined
        ) {
          let properties = Object.keys(action.project.project);
          properties.forEach((key) => {
            if (key === 'images') {
              let newImages = fromJS(action.project.project[key]);
              state = state.set(key, state.get(key).concat(newImages));
            } else {
              state = state.set(key, fromJS(action.project.project[key]));
            }
          });
        }
      }
      return state.set('loadingProject', false);
    case SET_REVIEW_PROJECT:
      return state.set('reviewPages', fromJS(action.project.project.pages));
    case ORIENTATION_TOGGLED:
      return fromJS({
        ...state.toJS(),
        ...action.project,
      });

    case NAME_CHANGED:
      state = state.set('name', action.name);
      state = state.set('projectAuthor', action.author);
      return state;

    case UPDATE_HEADERS:
      let changes = action.changes;
    //fall through
    case HEADERS_CHANGED:
      changes = changes || action.changes.changes;
      if (changes.previewSize) {
        state = state.set('previewSize', changes.previewSize);
      }
      if (changes.subType) {
        state = state.set('subType', changes.subType);
      }
      if (changes.theme) {
        state = state.set('theme', changes.theme);
      }

      return state;
    case CHANGE_PROJECT_STYLE:
      history.push(`${state.get('projectPK')}`);
      return state.set('paperTypeID', action.paperTypeID);
    case IMAGE_ADDED:
      let addedImage = action.image;
      return state.set('images', state.get('images').push(addedImage.imageID));
    case UPDATE_PAGE_NUMBER_STYLE:
      return state.setIn(
        ['preferences', 'pageNumberStyle'],
        fromJS(action.settings),
      );
    case UPDATE_COVER_TYPES:
      const ct = fromJS({
        hard: action.coverTypes.Hardcover,
        soft: action.coverTypes.Softcover,
      });
      return state.setIn(['preferences', 'coverType'], ct);
    case GENERATE_THUMB_COMPLETE:
      let thumbCount = (state.get('generatingThumbCount') ?? 0) - 1;
      return state.set('generatingThumbCount', thumbCount);
    case SET_GENERATE_THUMB_COUNT:
      return state.set('generatingThumbCount', action.count);
    default:
      return state;
  }
};

const actionFilter = includeAction([
  PageItem.UPDATE_PAGE_ITEMS,
  Page.REPLACE_PAGE,
  PageItem.REMOVE_PAGE_ITEMS,
  Background.SET_BACKGROUND_IMAGE,
  Background.SET_BACKGROUND_COLOR_UNDOABLE,
  PageItem.ADD_LINE_PAGE_ITEM,
  PageItem.INSERT_PAGE_ITEMS,
  PageItem.ADD_PAGE_ITEMS,
  Page.RELOAD_SPREAD_UNDOABLE,
  Page.MOVE_DOWN,
  Page.MOVE_TO_BOTTOM,
  Page.MOVE_TO_TOP,
  Page.MOVE_UP,
  SET_PROJECT_UNDOABLE,
  SPREAD_DELETED,
  SPREADS_ADDED,
]);

const mainReducer = undoable(
  combineReducers({
    metadata: projectReducer,
    pageItems: pageItems.reducer,
    reviewProject: reviewProject.reducer,
    pages: pages.reducer,
    imageUsage: imageUsage.reducer,
    sections: sections.reducer,
    productInfo: productInfo.reducer,
  }),
  { filter: actionFilter, syncFilter: true },
);

/**
 * actions
 */

export function renameProject(name, author = null) {
  return {
    type: RENAME_PROJECT,
    name,
    author,
  };
}

export function updatePageNumberStyle(settings) {
  return {
    type: UPDATE_PAGE_NUMBER_STYLE,
    settings,
  };
}

export function setProjectStyle(productPK, paperType) {
  return {
    type: CHANGE_PROJECT_STYLE,
    productPK,
    paperType,
  };
}

export function loadProject(
  projectPK,
  section = null,
  spread = null,
  redraw = false,
) {
  return {
    type: LOAD_PROJECT,
    projectPK,
    section,
    spread,
    redraw,
  };
}

export function shareProject(shareID) {
  return {
    type: SHARE_PROJECT,
    shareID,
  };
}

export function updateWarnings(warnings) {
  return {
    type: UPDATE_WARNINGS,
    warnings,
  };
}

export function loadProjectUndoable(projectPK, spread = null) {
  return {
    type: LOAD_PROJECT_UNDOABLE,
    projectPK,
    spread,
  };
}

export function setProject(project) {
  return {
    type: SET_PROJECT,
    project,
  };
}

export function setProjectUndoable(project) {
  return {
    type: SET_PROJECT_UNDOABLE,
    project,
  };
}

export function addProjectImage(image) {
  return {
    type: ADD_PROJECT_IMAGE,
    image: image,
  };
}

export function addProjectImageRef(action) {
  return {
    type: ADD_PROJECT_IMAGE_REF,
    ...action,
  };
}

export function deleteProjectImageRef(action) {
  return {
    type: DELETE_PROJECT_IMAGE_REF,
    ...action,
  };
}
export function removeProjectImage(image) {
  return {
    type: REMOVE_PROJECT_IMAGE,
    image: image,
  };
}

export function removeProjectUnusedImages() {
  return {
    type: REMOVE_PROJECT_UNUSED_IMAGES,
  };
}

export function saveSpreadFromStore(spreadID, pages) {
  return {
    type: SAVE_SPREAD_FROM_STORE,
    spreadID,
    pages,
  };
}

export function saveCurrentSpreadsFromStore(spreadID, pages) {
  return {
    type: SAVE_CURRENT_SPREADS_FROM_STORE,
  };
}

export function spreadDeleted(spreadID) {
  return {
    type: SPREAD_DELETED,
    spreadID,
  };
}

export function spreadsAdded(sectionID, insertIndex, spreads) {
  return {
    type: SPREADS_ADDED,
    sectionID,
    insertIndex,
    spreads,
  };
}

export function toggleOrientation() {
  return {
    type: TOGGLE_ORIENTATION,
  };
}

export function updateHeaders(changes) {
  return {
    type: UPDATE_HEADERS,
    changes,
  };
}

export function undo() {
  return {
    type: UNDO,
  };
}

export function redo() {
  return {
    type: REDO,
  };
}

export function uploadThumb() {
  return {
    type: UPLOAD_THUMB,
  };
}

export function updateCoverTypes(coverTypes) {
  return {
    type: UPDATE_COVER_TYPES,
    coverTypes,
  };
}

export function createNewPageThumb() {
  return {
    type: CREATE_NEW_PAGE_THUMB,
  };
}

export function updatePageNumberSettings(settings) {
  return {
    type: UPDATE_PAGE_NUMBER_SETTINGS,
    settings,
  };
}

export function autoFillProject(force) {
  return { type: AUTO_FILL_PROJECT, force };
}

/**
 * Sagas
 */

function* loadProjectHandler(undoable, action) {
  try {
    // getting sleepy so we can use the debugger
    //  yield delay(3000);

    let project = null;
    let spread;
    try {
      let section = action.section;
      spread =
        action.spread != null
          ? action.spread
          : getParameterByName('s') || 'first';
      let include = 'header,sections,imagesWithUsage,productInfo,warnings';
      let projectPK = { projectPK: action.projectPK };
      project = yield getProject(projectPK, include, null, section, spread);

      let isPreview = getParameterByName('preview') !== null;
      if (
        isPreview ||
        (project &&
          project.project.permissions &&
          project.project.permissions.view)
      ) {
        yield put(enterPreviewMode());
      }

      let location = `${obfuscateProjectId(action.projectPK)}`;
      let appender = '?';
      if (spread && spread !== 'first') {
        location = location + `?s=${spread}`;
        appender = '&';
      }

      if (isPreview) {
        location = location + `${appender}preview`;
        appender = '&';
      }

      if (getParameterByName('cid')) {
        location = location + `${appender}cid=${getParameterByName('cid')}`;
        appender = '&';
      }

      history.push(location);
    } catch (error) {
      console.error('error loading project', error);
    }
    if (!project.currentSection && (action.section || action.spread)) {
      window.location.href = process.env.libraryUrl;
      return;
    }

    if (
      project &&
      spread &&
      spread !== 'first' &&
      project.pages &&
      project.pages.length === 0
    ) {
      //tried to load a spread that is not in the book - load the first.
      if (action.depth) {
        return;
      }
      yield loadProjectHandler(undoable, {
        ...action,
        spread: 'first',
        depth: 1,
      });
      return;
    }

    let images = yield select(Selectors.projectImagesSelector);
    let missing = [];

    // if(project.imagesToCache) {
    //     for(let img of project.imagesToCache) {
    //         if(!images.get(img.id) && !project.images[img.id]) {
    //             missing.push(img.id);
    //         }
    //     }
    // }

    //we need to fix layout fonts, a lot of them are set to "Microsoft Sans Serif"
    if (project.pageItems) {
      let validFontNames = yield select(Selectors.validFontSelector);
      Object.keys(project.pageItems).forEach((key) => {
        let pageItem = project.pageItems[key];
        if (pageItem.itemType === PicabooConstants.ITEM_TYPES.CAPTION) {
          if (!validFontNames.includes(pageItem.fontFamily)) {
            pageItem.fontFamily = 'Arial';
            project.pageItems[key] = pageItem;
          }
        } else if (
          pageItem.itemType === PicabooConstants.ITEM_TYPES.GRAPHICITEM &&
          pageItem.imageID
        ) {
          //Here we look for images used on the pages but not included in the section
          if (
            !images.get(pageItem.imageID) &&
            !project.images[pageItem.imageID]
          ) {
            missing.push(pageItem.imageID);
          }
        }
      });
    }

    if (missing.length > 0) {
      let imageData = yield getImagesMetadata(action.projectPK, missing);

      //Add in these images to the project we just got back
      if (!project.images) {
        project.images = imageData.images;
      } else {
        for (let imageID of imageData.project.images) {
          let img = imageData.images[imageID];
          if (!img) {
            img = imageData.images[imageID.toLowerCase()];
          }
          if (img) {
            project.images[img.imageID] = img;
          } else {
            console.warn('metadata not found for imageID: ' + imageID);
          }
        }
      }

      if (!project.project.images || project.project.images.length === 0) {
        project.project.images = imageData.project.images;
      } else {
        for (let imageID of imageData.project.images) {
          if (imageData.images[imageID]) {
            project.project.images.push(imageID);
          }
        }
      }
    }
    yield put(selectSection(project.currentSection));
    yield put(setLoadedImagesSection(project.currentSection));

    if (project.project.type == PicabooConstants.PRODUCT_TYPES.YEARBOOK_AD) {
      const adSize = parseInt(project.project.cover.substr(-1));
      if (adSize > PicabooConstants.AD_TYPES.QUARTER_PAGE) {
        yield put(setZoomLevel(150));
      } else if (adSize > PicabooConstants.AD_TYPES.HALF_PAGE) {
        yield put(setZoomLevel(125));
      }
    }

    if (undoable) {
      yield put(setProjectUndoable(project));
    } else {
      let msg = setProject(project);
      if (action.keepSelectedTab) msg = keepSelectedTab(msg);
      yield put(msg);
      yield put(ActionCreators.clearHistory());
    }

    if (project.pages) {
      const selectedProject = yield select(Selectors.projectMetadataSelector);
      const pages = yield select(Selectors.pagesSelector);
      const section = yield select(Selectors.sectionSelector);

      // Maintain the existing page selection if the page still exists
      const selectedPages = yield select(Selectors.selectedPages);
      let pageId = undefined;
      if (selectedPages.size) {
        const selectedPageId = selectedPages.first().get('id');
        if (pages.has(selectedPageId)) {
          pageId = selectedPageId;
        }
      }

      if (!pageId) {
        pageId = getDefaultSelectedPage(selectedProject, pages, section.toJS());
      }

      // should be a dictionary - an array of keys
      if (pageId) {
        yield put(selectPages([pageId]));
        let pageItemId = getDefaultSelectedPageItem(project, pageId);

        // should be a dictionary - an array of keys
        if (pageItemId !== null) {
          yield put(selectPageItems([pageItemId]));
        }
      }

      if (!undoable) {
        if (action.redraw) {
          yield put(renderCanvasFromStore());
        }
      } else {
        yield put(ActionCreators.clearHistory());
        yield put(renderCanvasFromStore());
        const allPages = yield select(Selectors.projectPagesSelector);
        if (allPages.length == 1) {
          yield handleCreateThumbnail();
        }
      }

      // if (selectedPage.has('background') && selectedPage.get('background').has('color')) {
      //     yield put(setBackgroundColor([selectedPage], selectedPage.get('background').get('color')))
      // }

      if (action.uploadThumbAfterLoad || getParameterByName('newProject')) {
        yield put(uploadThumb());
      }
    }
    yield call(setWrapAndSKU, project);
  } catch (error) {
    console.error('error loading project', error);
    throw new Error(error);
  }
}

function* shareProjectHandler(action) {
  try {
    let project = null;
    let spread;
    try {
      spread = getParameterByName('s') || 'first';
      let shareID = { shareID: action.shareID };
      let include = 'header,sections,imagesWithUsage,productInfo';
      project = yield getProject(shareID, include, null, null, spread);
      yield put(enterShareView());
      yield put(enterPreviewMode());
    } catch (error) {
      console.error('error loading project', error);
    }

    yield put(selectSection(project.currentSection));
    yield put(setLoadedImagesSection(project.currentSection));

    yield put(setProject(project));
    yield call(setWrapAndSKU, project);
  } catch (error) {
    console.error('error loading project', error);
    throw error;
  }
}

function* setWrapAndSKU(project) {
  if (
    project.productInfo.availableSizes &&
    Array.isArray(project.productInfo.availableSizes) &&
    project.productInfo.availableSizes.length > 0
  ) {
    let size = project.productInfo.availableSizes[0];

    if (project.project.previewSize) {
      for (let s of project.productInfo.availableSizes) {
        //using == on purpose here
        if (s.id == project.project.previewSize) {
          size = s;
          break;
        }
      }
    }

    if (
      project.sections[project.currentSection].type ===
      PicabooConstants.SECTION_TYPES.TYPE_COVER
    )
      yield put(setWrapDimensions(size.coverWrapX, size.coverWrapY));
    else {
      yield put(
        setWrapDimensions(
          size.safetyX || size.wrapX,
          size.safetyY || size.wrapY,
        ),
      );
    }

    yield put(setSelectedSKU(size.sku));
  }
}

export function getDefaultSelectedPage(project, pages, section) {
  let type = project.get('type');
  switch (type) {
    case PicabooConstants.PRODUCT_TYPES.BOOK:
      //if on inside cover, select other page
      if (
        section.type !== PicabooConstants.SECTION_TYPES.TYPE_COVER &&
        pages.get(project.get('pages').get(0)).get('pageType') ===
          PicabooConstants.PAGE_TYPES.COVER
      ) {
        return project.get('pages').get(1);
      }
      return project.get('pages').get(0);
  }

  return null;
}

export function getDefaultSelectedPageItem(project, defaultPageID) {
  let type = project.project.type;
  switch (type) {
    case PicabooConstants.PRODUCT_TYPES.PRINTS:
      return project.pages[defaultPageID].background.graphicItem;
  }

  return null;
}

// function* orientationToggledSaga(action) {
//
//
//     yield put(orientationToggled(action.project));
//
//     yield put({
//         type: PAGES_UPDATED,
//         pages: action.pages,
//         leftovers: action.leftovers,
//         replace: true
//     });
//
//     yield put(setCurrentLayouts(action.layouts));
//
//     yield put(ActionCreators.clearHistory());
//
//     yield put(renderCanvasFromStore());
// }

function* undoRedoSaga(action) {
  let previousSpreadCount = 0;
  let currentSpreadCount = 0;

  let projectMetaOld = yield select(Selectors.projectMetadataSelector);
  let spreads = yield spreadsForUndo();

  previousSpreadCount = spreads.length;

  if (action.type === UNDO) {
    let history = yield select(Selectors.undoHistorySelector);
    if (history.length > 0) {
      yield put(ActionCreators.undo());
    }
  } else {
    let history = yield select(Selectors.redoHistorySelector);
    if (history.length > 0) {
      yield put(ActionCreators.redo());
    }
  }

  let projectMetaNew = yield select(Selectors.projectMetadataSelector);
  if (
    projectMetaNew &&
    projectMetaOld &&
    (projectMetaNew.get('ratio') !== projectMetaOld.get('ratio') ||
      projectMetaNew.get('style') !== projectMetaOld.get('style') ||
      projectMetaNew.get('subtype') !== projectMetaOld.get('subtype'))
  ) {
    yield put(
      updateHeaders({
        style: projectMetaNew.get('style'),
        subType: projectMetaNew.get('subtype'),
        ratio: projectMetaNew.get('ratio'),
      }),
    );
  }

  yield put(clearSelection());
  yield put(saveSpreadFromStore());

  spreads = yield spreadsForUndo();
  currentSpreadCount = spreads.length;
  if (currentSpreadCount !== previousSpreadCount) {
    //we appear to be undoing a page add or remove (or converting from a 2-page spread to individual pages)
    yield put(saveCurrentSpreadsFromStore());
  }

  yield put(renderCanvasFromStore());
  yield handleCreateThumbnail({ sendChangeset: true });
}

function* spreadsForUndo() {
  let spreads = [];
  let sections = [];
  let currentSections = yield select(Selectors.projectSectionsSelector);
  sections = currentSections.toJS();

  Object.keys(sections).forEach((key) => {
    let section = sections[key];
    spreads = spreads.concat(section.spreads);
  });

  return spreads;
}

export function* sagaAutoFillProject(action) {
  try {
    let uploadPhotoCount = yield select(imagesToUploadCount);
    let isWaitPrompted = yield select(
      (state) => state.navigation.showAutoFillWaitModal,
    );
    //if already showing modal and images are done uploading
    if (uploadPhotoCount === 0 && isWaitPrompted) {
      yield put(toggleAutoFillWaitModal());
    } else if (uploadPhotoCount > 0) {
      yield put(toggleAutoFillWaitModal());
      return;
    }

    let isPrompted = yield select(
      (state) => state.navigation.showAutoFillPromptModal,
    );

    if (!isPrompted && (isWaitPrompted || action?.force)) {
      yield put(toggleAutoFillPromptModal(false));
    }
  } catch (e) {
    console.error('auto fill project saga error', e);
    throw e;
  }
}

function* setupSagas() {
  yield fork(pages.saga);
  yield fork(pageItems.saga);
  yield fork(productInfo.saga);
  yield fork(reviewProject.saga);
  yield takeLatest(LOAD_PROJECT, loadProjectHandler, false);
  yield takeLatest(SHARE_PROJECT, shareProjectHandler);
  yield takeLatest(LOAD_PROJECT_UNDOABLE, loadProjectHandler, true);
  yield takeEvery([UNDO, REDO], undoRedoSaga);
  yield takeEvery(AUTO_FILL_PROJECT, sagaAutoFillProject);
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: mainReducer,
  saga: setupSagas,
};
